import React, { Component } from 'react';
import { Card, Divider } from 'antd';
import { VictoryPie } from 'victory';
import ResultTotalAnswers from '../ResultTotalAnswers';
import ResultTitle from '../ResultTitle';

class ResultViePie extends Component{
	
	render() {
		const { id, stepAnswers, questions, chartData, colors } = this.props;
		
		return (
			<Card className='Result'>
				<div className='Answer'>
					<ResultTitle questions={questions} id={id}/>
					<ResultTotalAnswers stepAnswers={stepAnswers}/>
				</div>
				<Divider/>
				<div className='Answer' style={{ width: '100%', maxWidth: 500, margin: '0 auto' }}>
					<svg viewBox="0 0 900 800">
						<VictoryPie
							colorScale={colors}
							labelRadius={350}
							standalone={false}
							width={900} height={750}
							data={chartData}
							style={{
								labels: { fontSize: 26, fill: 'black' },
								data: {
									fillOpacity: 0.9, stroke: 'white', strokeWidth: 3
								}
							}}
						/>
					</svg>
				</div>
			</Card>
		);
	};
}

export default ResultViePie;




// WEBPACK FOOTER //
// ./src/components/ResultViePie/ResultViePie.js